module.exports = __webpack_public_path__ + "static/media/link.04770471.svg";